export enum Handing {
  RH = 'RH',
  LH = 'LH',
  LHR = 'LHR',
  RHR = 'RHR',
  NH = 'NH',
}
